<script>  
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';
    import {questionAnswers} from '../../stores';
    import {txt} from '../../i18n/i18n';    
    import {onMount} from 'svelte';

    onMount(() => { 
        if (!answer.text) {
            answer.text = '';
        }
     });
  
    export let question = { };
    /**
     * set true if you do not want answer to be displayed, useful when e.g. printing survey
     * @type {boolean}
     */
    export let hideAnswer = false;
    
    $: answer = $questionAnswers.find(a => a.questionId === question.questionId);
</script>

{#if hideAnswer}
    <TextField label={txt('Open_answer_heading')} type="area" rows=5 />
{:else }
    <TextField label={txt('Open_answer_heading')} type="area" bind:value={answer.text} maxlength={5000} rows=5 />
{/if}
